<template>
    <div class="user">
        <Modal
            v-model="showDelModal"
            :title="$t('confirm')+$t('lock')"
            @on-ok="showDelModal=false;lockUser(userIdToDel);"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>

        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">{{$t('searchText')}}</Button>
            <Button type="primary" class="add_user" icon="md-add" @click="show_add_user = true">{{$t('add')}}{{$t('user')}}</Button>
        </div>
        <Table border :columns="columns12" :data="data6" style="width: 100%; min-height: 500px;">
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
       
    </div>
</template>


<script>
import { formatUTCTime as formatUTC } from '../../common/common.js';

export default {
    data() {
        return {
            showDelModal: false,
            currentPage: 1,
            totalItems: 0,
            itemsPerPage: 10,
            search: "",
            columns12: [
                {
                    title: "ID",
                    key: "user_id"
                },
                {
                    title: this.$i18n.t('username'),
                    key: "member_username"
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 120,
                    key: "member_mobile"
                },
                {
                    title: this.$i18n.t('amount'),
                    key: "amount",
                },
                {
                    title:this.$i18n.t('userView.bankNumber'),
                    key: "network",
                    render: (h, params) => {
                        return h("span", params.row.network == 'bank' ? '银行' : '支付宝');
                    }
                },
                {
                    title:this.$i18n.t('userView.bankName'),
                    key: "address",
                },
                {
                    title: this.$i18n.t('userView.cardholderName'),
                    key: "member_real_name",
                },
                {
                    title: this.$i18n.t('status'),
                    width: 100,
                    align: "center",
                    render: (h, params) => {
                        if (params.row.status == 0) {
                            return h("div", [
                                h("Select", {
                                    props: {
                                        value: params.row.status,
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            this.edit_status(params.row, value)
                                        }
                                    }
                                }, [
                                    h("Option", {
                                        props: {
                                            value: 1
                                        }
                                    }, this.$i18n.t('pass')),
                                    h("Option", {
                                        props: {
                                            value: 2
                                        }
                                    }, this.$i18n.t('reject'))
                                ])
                            ])
                        } else {
                            return h("span", {
                                style: {
                                    color: params.row.status == 1 ? 'green' : 'red'
                                }
                            }, params.row.status == 1 ? this.$i18n.t('pass') : this.$i18n.t('reject'))
                        }
                    }
                },
                {
                    title:this.$i18n.t('note'),
                    width: 150,
                    key: "remark",
                    render: (h, params) => {
                        if (params.row.status == 2) {
                            return h("div", [
                                h("Input", {
                                    props: {
                                        value: params.row.remark || '',
                                        style: {width: '100%'}
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            this.edit_remark(params.row, event.target.value)
                                        }
                                    }
                                })
                            ])
                        } else {
                            return h("span", params.row.remark || '-')
                        }
                    }
                },
                {
                    title:this.$i18n.t('action'),
                    width: 110,
                    key: "action",
                    render: (h, params) => {
                        return h("div",{style:{display: 'flex', flexDirection: 'row', justifyContent: 'space-between',gap: '5px'}}, [
                            h("Icon", {
                                props: {
                                    type: 'md-trash',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                   backgroundColor: 'red',
                                   border: 'none',
                                   },
                                on: {
                                    click: () => {
                                        this.delRow(params.row.id)
                                    }
                                }
                            }),
                        ]);
                    }
                },
                {
                    title:'copy',
                    key:'copy',
                    render:(h,params)=>{
                       return h("Icon", {
                                props: {
                                    type: 'md-copy',
                                    size: 24,
                                    color: 'white'
                                },
                                style: {
                                   backgroundColor: 'green',
                                   border: 'none',
                                   },
                                on: {
                                    click: () => {
                                        this.copy(params.row)
                                    }
                                }
                            })
                    }
                }
            ],
            data6: [],
            modalAdd: {
                mobile: "",
                pass: ""
            },
            modalEdit:{
                user_id:'',
                pass:'',
                type:0
            },
            show_add_user: false,
            show_edit_pass:false
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            
            this.$get(this.$path.wallet_list, {
                search: this.search,
                page: this.currentPage,
                type: "withdraw"
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        edit_status(row, status) {
            this.$post(this.$path.wallet_edit, {
                id: row.id,
                user_id: row.user_id,
                type: "withdraw",
                status: status,
                amount: row.amount,
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        edit_remark(row, remark) {
            this.$post(this.$path.wallet_edit, {
                user_id: row.user_id,
                remark: remark,
                id: row.id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        delRow(id) {
            this.$post(this.$path.wallet_del, {
                id: id
            }).then(res => {
                if (res.errcode == 0) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        copy(row){
            const text= `提现金额:${row.amount}
银行名称:${row.network == 'bank' ? row.member_open_bank : '支付宝'} 
卡主姓名:${row.member_real_name} 
卡号:${row.address}
内容:提现
`
            navigator.clipboard.writeText(text).then(()=>{
                this.$Message.success(this.$i18n.t('operateSuccess'));
            }).catch(()=>{
                this.$Message.error(this.$i18n.t('operateFailed'));
            });
        },
        formatUTCTime(utcTimeString) {
            return formatUTC(utcTimeString, 8); // 使用东八区
        }
    }
};
</script>


<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
    .add_user {
        float: right;
    }
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/withdraw.vue